module.exports = __webpack_public_path__ + "static/media/4.23c82088.png";